import api from './client';
import type { ApiResponse, NewsResponse } from '../../types/api';

export const getNews = async (): Promise<NewsResponse> => {
  return api.get<any, NewsResponse>('/api/news');
};

export const getAdminNews = async (): Promise<NewsResponse> => {
  return api.get<any, NewsResponse>('/api/news/admin');
};

export const createNewsItem = async (newsData: {
  title: string;
  content: string;
  priority?: number;
  active?: boolean;
}): Promise<ApiResponse> => {
  return api.post<any, ApiResponse>('/api/news', newsData);
};

export const updateNewsItem = async (id: string, newsData: {
  title?: string;
  content?: string;
  active?: boolean;
  priority?: number;
}): Promise<ApiResponse> => {
  return api.put<any, ApiResponse>(`/api/news/${id}`, newsData);
};

export const deleteNewsItem = async (id: string): Promise<ApiResponse> => {
  return api.delete<any, ApiResponse>(`/api/news/${id}`);
};